<form *ngIf="exibir" [formGroup]="enderecoForm" (change)="cadastrarEndereco()">
  <div class="container__titulo_endereco mb-2">
    <div class="titulo__endereco" [hidden]="!controleExibicaoDescricao">
      <label class="lbl__descricao_endereco">
        <img
          [src]="this.obterIconeDescricao(this.endereco?.enderecoPrincipal)"
          class="icone__imagem"
        />
        {{ this.enderecoForm.value.descricao }}
        <span class="lbl__principal" *ngIf="this.endereco?.enderecoPrincipal">
          <i class="fa__icone_principal">●</i> Principal
        </span>
      </label>
    </div>
    <div class="box_input_nome" [hidden]="controleExibicaoDescricao">
      <div class="input_nome">
        <!-- <img
          [src]="this.obterIconeDescricao(this.endereco?.enderecoPrincipal)"
          class="icone__imagem"
        />
        <input
          class="lovers-input nome__endereco"
          type="text"
          formControlName="descricao"
          id="descricao"
          #descricao
          (change)="this.exibirLabelDescricao(true)"
          placeholder="Dê um nome para o seu endereço"
        /> -->

        <shared-input-lovers
          #descricao
          (change)="this.exibirLabelDescricao(true)"
          [placeholder]="'Dê um nome para o seu endereço'"
          [controlName]="'descricao'"
          [label]="'Nome do endereço'"
        ></shared-input-lovers>
      </div>
    </div>
    <div [hidden]="!controleExibicaoDescricao">
      <div class="dropdown">
        <button
          (click)="this.abrirOpcoes(this.idIndex)"
          class="btn btn-link btn__dropdown dropdown-toggle"
          type="button"
          id="{{ 'dropdownMenuButton-' + this.idIndex }}"
        >
          ...
        </button>
        <div
          class="dropdown-menu"
          id="{{ 'dropdown-menu-' + this.idIndex }}"
          *ngIf="controleExibicaoDropdown"
        >
          <a
            class="dropdown-item"
            (click)="this.tornarPrincipal()"
            *ngIf="!this.endereco?.enderecoPrincipal"
            >Endereço Principal</a
          >
          <a class="dropdown-item" (click)="this.exibirLabelDescricao(false)"
            >Renomear</a
          >
          <a class="dropdown-item" (click)="this.removerEndereco()">Excluir</a>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="mensagem_aviso">
    <div
      *ngIf="
        enderecoForm.get('descricao').invalid &&
        enderecoForm.get('descricao').errors &&
        (enderecoForm.get('descricao').dirty ||
          enderecoForm.get('descricao').touched)
      "
    >
      <small
        class="text-danger lovers-font--bold"
        *ngIf="enderecoForm.get('descricao').hasError('required')"
      >
        Esse campo é obrigatório!
      </small>
    </div>
  </div> -->

  <div class="row mb-4">
    <div class="col-lg-2 col-md-6 col-sm-12 col-12">
      <shared-input-lovers
        [controlName]="'cep'"
        [label]="'CEP'"
        [mask]="'00000-000'"
        (keyup)="buscarCep($event)"
        (change)="buscarCep($event)"
      ></shared-input-lovers>
      <!-- <div class="lovers-input__container">
        <input type="text" class="campo__input" id="cep" formControlName="cep" pattern="[0-9]*" inputmode="numeric"
          mask="00000-000" placeholder=" " (keyup)="buscarCep($event)" (change)="buscarCep($event)" required [ngClass]="{
        'invalid-input':
          enderecoForm.get('cep').invalid &&
          enderecoForm.get('cep').errors &&
          (enderecoForm.get('cep').dirty ||
            enderecoForm.get('cep').touched)
      }" />
        <label for="cep" class="campo__label lovers-font--bold lovers-label-disabled">
          CEP
        </label>
        <div class="invalid__container" *ngIf="
        enderecoForm.get('cep').invalid &&
        enderecoForm.get('cep').errors &&
        (enderecoForm.get('cep').dirty ||
          enderecoForm.get('cep').touched)
      ">
          <small class="invalid-text" *ngIf="enderecoForm.get('cep').hasError('required')">
            Esse campo é obrigatório!
          </small>
          <small class="text-danger lovers-font--bold" *ngIf="enderecoForm.get('cep').hasError('minlength')">
            Esse campo tem que ter 8 caracteres
          </small>
        </div>
      </div> -->
    </div>

    <div
      class="col-lg-2 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2"
    >
      <shared-input-lovers
        [controlName]="'numero'"
        [label]="'Número'"
        [maxlength]="50"
      ></shared-input-lovers>

      <!-- <div class="lovers-input__container">
        <input
          type="text"
          class="campo__input"
          id="numero"
          formControlName="numero"
          [maxLength]="50"
          placeholder=" "
          required
          [ngClass]="{
            'invalid-input':
              enderecoForm.get('numero').invalid &&
              enderecoForm.get('numero').errors &&
              (enderecoForm.get('numero').dirty ||
                enderecoForm.get('numero').touched)
          }"
        />
        <label
          for="numero"
          class="campo__label lovers-font--bold lovers-label-disabled"
        >
          Número
        </label>
        <div
          class="invalid__container"
          *ngIf="
            enderecoForm.get('numero').invalid &&
            enderecoForm.get('numero').errors &&
            (enderecoForm.get('numero').dirty ||
              enderecoForm.get('numero').touched)
          "
        >
          <small
            class="invalid-text"
            *ngIf="enderecoForm.get('numero').hasError('required')"
          >
            Esse campo é obrigatório!
          </small>
        </div>
      </div> -->
    </div>

    <div
      class="col-lg-8 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2"
    >
      <shared-input-lovers
        [controlName]="'complemento'"
        [label]="'Complemento'"
        [maxlength]="100"
      ></shared-input-lovers>

      <!-- <div class="lovers-input__container">
        <input
          type="text"
          class="campo__input"
          id="complemento"
          [maxLength]="100"
          formControlName="complemento"
          placeholder=" "
          [ngClass]="{
            'invalid-input':
              enderecoForm.get('complemento').invalid &&
              enderecoForm.get('complemento').errors &&
              (enderecoForm.get('complemento').dirty ||
                enderecoForm.get('complemento').touched)
          }"
        />
        <label
          for="complemento"
          class="campo__label lovers-font--bold lovers-label-disabled"
        >
          Complemento
        </label>
      </div> -->
    </div>
  </div>

  <div class="row mb-4" *ngIf="controleExibicaoEndereco">
    <div class="col-lg-6 col-md-4 col-sm-12 col-12 mb-2">
      <shared-input-lovers
        [controlName]="'logradouro'"
        [label]="'Endereço'"
        [maxlength]="400"
        [ngClass]="{ campo__input: this.habilitarCampoBairro }"
        [tab]="
          !this.enderecoForm.controls['logradouro'].value == '' ? '-1' : ''
        "
        [disabled]="
          !this.enderecoForm.controls['logradouro'].value == '' ? true : false
        "
      ></shared-input-lovers>
      <!-- <div class="lovers-input__container">
        <label class="lovers-label lovers-font--bold lovers-label-disabled"
          >Endereço</label
        >
        <input
          type="text"
          [maxLength]="400"
          class="lovers-input lovers lover lovers-input-disabled"
          formControlName="logradouro"
          id="logradouro"
          [attr.disabled]="!this.habilitarCampoLogradouro ? true : null"
          [ngClass]="{ campo__input: this.habilitarCampoLogradouro }"
        />
      </div> -->
      <!-- <div
        class="pl-1"
        *ngIf="
          enderecoForm.get('logradouro').invalid &&
          enderecoForm.get('logradouro').errors &&
          (enderecoForm.get('logradouro').dirty ||
            enderecoForm.get('logradouro').touched)
        "
      >
        <small
          class="text-danger lovers-font--bold"
          *ngIf="enderecoForm.get('logradouro').hasError('required')"
        >
          Esse campo é obrigatório!
        </small>
      </div> -->
    </div>

    <div class="col-lg-2 col-md-6 col-sm-12 col-12 mb-2">
      <shared-input-lovers
        [controlName]="'bairro'"
        [label]="'Bairro'"
        [ngClass]="{ campo__input: this.habilitarCampoBairro }"
        [tab]="!this.enderecoForm.controls['bairro'].value == '' ? '-1' : ''"
        [disabled]="
          !this.enderecoForm.controls['bairro'].value == '' ? true : false
        "
      ></shared-input-lovers>

      <!-- <div class="lovers-input__container">
        <label
          for="estado"
          class="lovers-label lovers-font--bold lovers-label-disabled"
          >Bairro</label
        >
        <input
          type="text"
          class="lovers-input lovers-input-disabled"
          formControlName="bairro"
          id="bairro"
          [attr.disabled]="!this.habilitarCampoBairro ? true : null"
          [ngClass]="{ campo__input: this.habilitarCampoBairro }"
        />
      </div> -->
    </div>

    <div class="col-lg-2 col-md-6 col-sm-12 col-12">
      <shared-input-lovers
        [controlName]="'estado'"
        [label]="'Estado'"
        [tab]="'-1'"
        [disabled]="true"
      ></shared-input-lovers>

      <!-- <div class="lovers-input__container">
        <label
          for="estado"
          class="lovers-label lovers-font--bold lovers-label-disabled"
          >Estado</label
        >
        <input
          type="text"
          class="lovers-input lovers-input-disabled"
          formControlName="estado"
          id="estado"
          disabled="true"
        />
      </div> -->
    </div>

    <div
      class="col-lg-2 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2"
    >
      <shared-input-lovers
        [controlName]="'cidade'"
        [label]="'Cidade'"
        [tab]="'-1'"
        [disabled]="true"
      ></shared-input-lovers>

      <!-- <div class="lovers-input__container">
        <label
          for="cidade"
          class="lovers-label lovers-font--bold lovers-label-disabled"
          >Cidade</label
        >
        <input
          type="text"
          class="lovers-input lovers-input-disabled"
          formControlName="cidade"
          id="cidade"
          disabled="true"
        />
      </div> -->
    </div>
  </div>

  <!-- <div class="row mb-4" [hidden]="true">
    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
      <div class="lovers-input__container">
        <label for="bairro" class="lovers-label lovers-font--bold">Bairro</label>
        <input type="text" class="lovers-input lovers--disabled" formControlName="bairro" id="bairro" disabled="true" />
      </div>
    </div>

    <div class="col-lg-6 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-sm-2 mt-2">
      <div class="lovers-input__container">
        <label class="lovers-label lovers-font--bold">País</label>
        <input type="text" class="lovers-input lovers--disabled" formControlName="pais" id="pais" />
      </div>
    </div>
  </div> -->

  <!-- <div class="row mb-4" *ngIf="this.tipoAcao === this.CADASTRO"> -->
  <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-6">
      <button type="button" (click)="cancelarCadastro()" class="lovers-button color__cancel">Cancelar</button>
    </div> -->
  <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-6">
      <button class="lovers-button" [disabled]="salvandoEndereco || !this.enderecoForm.valid"
        [ngClass]="{ 'lovers--disabled': salvandoEndereco || !this.enderecoForm.valid }">
        Salvar
        <i *ngIf="salvandoEndereco" class="fa fa-spinner fa-spin"></i>
      </button>
    </div> -->
  <!-- </div> -->
</form>
